import { Sunrise, Moon } from 'lucide-react'

const RUN_LABEL: Record<string, { label: string; short: string; icon: typeof Sunrise }> = {
  run1: { label: 'RUN 1 · Madrugada / Mañana', short: 'RUN 1', icon: Sunrise },
  run2: { label: 'RUN 2 · Tarde / Noche', short: 'RUN 2', icon: Moon },
}

/** Fase R.8: indicador de qué franja del día se está mostrando cuando la navegación llega
 * con `?run=run1|run2` desde el Home -- deja inequívoco a qué corrida pertenece lo que se ve,
 * sin necesitar texto adicional en cada tarjeta.
 *
 * Fase R.11 (Bloque C, 17/08/2026): `compact` -- variante pequeña pensada para ir DENTRO de
 * cada tarjeta individual (Pick/Parlay/Exacto) cuando la página muestra la vista combinada del
 * día (RUN1 + RUN2 juntas, sin `?run=` explícito en la URL) -- cada elemento debe poder
 * identificar de qué corrida proviene sin tener que salir de la lista (ver `mergeRuns.ts`).
 * Nunca se mezcla una selección de RUN1 dentro de RUN2: este badge es puramente informativo,
 * el origen real ya viene decidido por el merge, no por este componente. */
export function RunBadge({ runType, compact = false }: { runType: string; compact?: boolean }) {
  const info = RUN_LABEL[runType]
  if (!info) return null
  const Icon = info.icon
  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-panel-elevated border border-border/50 text-[9px] font-black uppercase tracking-wider text-text-dim shrink-0">
        <Icon className="h-2.5 w-2.5" />
        {info.short}
      </span>
    )
  }
  return (
    <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-panel-elevated border border-border/60 text-[10px] font-black uppercase tracking-wider text-text-dim">
      <Icon className="h-3 w-3" />
      <span>{info.label}</span>
    </div>
  )
}
